import * as _ from 'underscore';
import { L10n } from '../L10n/L10n';
import { ConfirmDialogInputNumberScope } from '../models/ConfirmDialogInputNumberScope';
import { RunFlowTaskInfo } from '../models/RunFlowTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { RunFlowTasks } from '../resources/RunFlowTasks';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class ChangeRunFlowTasksPriorityAction extends AbstractContentAction<RunFlowTaskInfo> {

  public static $inject = [
    '$translate',
    'ConfirmActionDialog',
    'ContentActionNotification',
    'RunFlowTasks'
  ];

  constructor(
    private $translate: ng.translate.ITranslateService,
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private RunFlowTasks: RunFlowTasks
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, runFlowTaskInfos: Set<RunFlowTaskInfo>) {

    const scope = <ConfirmDialogInputNumberScope> dialogConfig.scope;

    if(runFlowTaskInfos.size() === 1) {
      const task = runFlowTaskInfos.first();
      scope.description = this.$translate.instant('runFlowTasksSetPriorityPrompt', {
        FLOW_NAME: L10n.elideIfLong(task.flow.name)
      });
    } else {
      scope.description = this.$translate.instant('runFlowTasksSetPriorityMultiplePrompt', {
        ITEM_COUNT: runFlowTaskInfos.size()
      }, L10n.Interpolations.Count);
    }

    scope.numberDescription = this.$translate.instant('createScheduleFormPriorityDescription');

    scope.input = {
      num: Math.min.apply(Math, _.map(runFlowTaskInfos.toArray(), (tasks: RunFlowTaskInfo) => tasks.priority)),
      min: RunFlowTasks.MIN_PRIORITY,
      max: RunFlowTasks.MAX_PRIORITY,
      isInteger: true,
      width: '75px'
    };

    dialogConfig.bodyTemplateUrl = 'confirmActionDialogInputNumber.html';
    dialogConfig.title = this.$translate.instant('tasksSetPriority');
    dialogConfig.actionName = this.$translate.instant('tasksSetPriorityConfirm', {
      ITEM_COUNT: runFlowTaskInfos.size()
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.RunFlowTasks.setPriority(runFlowTaskInfos.keys(), scope.input.num);
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'runFlowTasksSetPrioritySuccess',
      errorId: 'runFlowTasksSetPriorityError'
    };
  }

}

Module.instance().service('ChangeRunFlowTasksPriorityAction', ChangeRunFlowTasksPriorityAction);
